const DEFAULT_TITLE = 'Artificial Intelligence & Machine Learning Events';
const DEFAULT_TITLE_SHORT = 'AI & ML Events';

export default (title?: string) => {
  if (title)
    return `${title} | ${DEFAULT_TITLE_SHORT}`;
  else
    return DEFAULT_TITLE;
}
